// extracted by mini-css-extract-plugin
module.exports = {"AdSlotMail__mail":"bgf_a bhc_vf bhc_a bhc_q bhc_k","AdSlotMail__mail--notLoaded":"bgf_b bhc_eu bhc_bj bhc_vu","show-ad-not-loaded":"bgf_c","AdSlotMail__cta":"bgf_e"};